import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=2c5a8a5d&scoped=true"
import script from "./landing-page.vue?vue&type=script&lang=js"
export * from "./landing-page.vue?vue&type=script&lang=js"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=2c5a8a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a8a5d",
  null
  
)

export default component.exports